import {
  Button,
  Card,
  Col,
  Input,
  Row,
  Select,
  Table,
  DatePicker,
  message,
  Radio,
  Spin,
  Modal,
  Form,
} from "antd";
import { Component } from "react";
import moment from "moment";
import locale from "./../../constants/locale.json";
import "./ShiftLog.css";
const { Option } = Select;

const flexColumnOverflow = {
  display: "flex",
  flex: "auto",
  flexDirection: "column",
  overflowY: "scroll",
};
const flexColumn = {
  display: "flex",
  flex: "auto",
  flexDirection: "column",
};
const columns = [
  {
    title: "Type",
    dataIndex: "shift_type_display_name",
    align: "center",
    sorter: (a, b) =>
      (a.shift_type_display_name || "").localeCompare(
        b.shift_type_display_name || ""
      ),
  },
  {
    title: "Start Date Time",
    dataIndex: "start_time",
    align: "center",
    render: (start_time) => {
      return <>{moment(start_time).format("DD/MM/YYYY HH:mm")}</>;
    },
    sorter: (a, b) => moment(a.start_time).unix() - moment(b.start_time).unix(),
  },
  {
    title: "End Date Time",
    dataIndex: "end_time",
    align: "center",
    render: (end_time) => {
      if (!end_time) {
        return <>-</>;
      }
      return <>{moment(end_time).format("DD/MM/YYYY HH:mm")}</>;
    },
    sorter: (a, b) => moment(a.end_time).unix() - moment(b.end_time).unix(),
  },
  {
    title: "Total Ticket Count",
    dataIndex: "total_count_ticket",
    align: "center",
    render: (total_count_ticket, row) => {
      if (!row.end_time) {
        return <>-</>;
      }
      return <>{total_count_ticket}</>;
    },
  },
  {
    title: "Total Ticket Amount (Riel)",
    dataIndex: "total_amount_ticket",
    align: "center",
    render: (total_amount_ticket, row) => {
      if (!row.end_time) {
        return <>-</>;
      }
      return <>{total_amount_ticket}</>;
    },
  },
  {
    title: "Total New Card Count",
    dataIndex: "total_count_newcard",
    align: "center",
    render: (total_count_newcard, row) => {
      if (!row.end_time) {
        return <>-</>;
      }
      return <>{total_count_newcard}</>;
    },
  },
  {
    title: "Total New Card Amount (Riel)",
    dataIndex: "total_amount_newcard",
    align: "center",
    render: (total_amount_newcard, row) => {
      if (!row.end_time) {
        return <>-</>;
      }
      return <>{total_amount_newcard}</>;
    },
  },
  {
    title: "Total Extend Card Count",
    dataIndex: "total_count_extendcard",
    align: "center",
    render: (total_count_extendcard, row) => {
      if (!row.end_time) {
        return <>-</>;
      }
      return <>{total_count_extendcard}</>;
    },
  },
  {
    title: "Total Extend Card Amount (Riel)",
    dataIndex: "total_amount_extendcard",
    align: "center",
    render: (total_amount_extendcard, row) => {
      if (!row.end_time) {
        return <>-</>;
      }
      return <>{total_amount_extendcard}</>;
    },
  },
  {
    title: "Total Lost Card Count",
    dataIndex: "total_count_lostcard",
    align: "center",
    render: (total_count_lostcard, row) => {
      if (!row.end_time) {
        return <>-</>;
      }
      return <>{total_count_lostcard}</>;
    },
  },
  {
    title: "Total Lost Card Amount (Riel)",
    dataIndex: "total_amount_lostcard",
    align: "center",
    render: (total_amount_lostcard, row) => {
      if (!row.end_time) {
        return <>-</>;
      }
      return <>{total_amount_lostcard}</>;
    },
  },
  {
    title: "Total Overtime Card Count",
    dataIndex: "total_count_overtime",
    align: "center",
    render: (total_count_overtime, row) => {
      if (!row.end_time) {
        return <>-</>;
      }
      return <>{total_count_overtime}</>;
    },
  },
  {
    title: "Total Overtime Card Amount (Riel)",
    dataIndex: "total_amount_overtime",
    align: "center",
    render: (total_amount_overtime, row) => {
      if (!row.end_time) {
        return <>-</>;
      }
      return <>{total_amount_overtime}</>;
    },
  },
  {
    title: "Assigned To",
    dataIndex: "start_user_name",
    align: "center",
    render: (username) => {
      return <>{!username ? "-" : username}</>;
    },
    sorter: (a, b) => (a.username || "").localeCompare(b.username || ""),
  },
];

const options = [
  { label: "PDF", value: "pdf" },
  { label: "Excel", value: "xlsx" },
];

export default class ShiftLog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logs: [],
      exportType: null,
      isExportModalVisible: false,
      isLoading: false,
      filterDateTimeStart: null,
      filterDateTimeEnd: null,
      filterUserName: null,
      exportDateStart: null,
      exportDateEnd: null,
    };
  }

  componentDidMount() {}

  onInputFieldChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      logs: [],
      [name]: value,
    });
  };

  onFieldChange = (name, value) => {
    this.setState({
      logs: [],
      [name]: value,
    });
  };

  onSearchClick = () => {
    const { accessToken } = this.props;
    const { filterDateTimeStart, filterDateTimeEnd, filterUserName } =
      this.state;
    this.setState({
      logs: [],
      isLoading: true,
    });
    return fetch(`/api/v1/report/shift/list`, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
        token: accessToken,
      },
      body: JSON.stringify({
        filterDateTimeStart,
        filterDateTimeEnd,
        filterUserName,
      }),
    })
      .then((res) => {
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
      })
      .then((data) => {
        const { logs } = data;
        if (logs.length === 0) {
          message.warning("No logs returned!");
        }
        return this.setState({
          logs,
        });
      })
      .catch((err) => {
        message.error(
          err instanceof Error ? err.message : "Server cannot be reached"
        );
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  onClearClick = () => {
    this.setState({
      logs: [],
      filterDateTimeStart: null,
      filterDateTimeEnd: null,
      filterUserName: null,
    });
  };

  isFiltered = () => {
    const { filterDateTimeStart, filterDateTimeEnd, filterUserName } =
      this.state;
    return !!filterDateTimeStart || !!filterDateTimeEnd || !!filterUserName;
  };

  getReport = (reportType) => {
    const { accessToken } = this.props;
    const { exportDateStart, exportDateEnd } = this.state;

    this.setState({
      isLoading: true,
    });
    fetch(`/api/v1/report/shift/download/${reportType}`, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
        token: accessToken,
      },
      body: JSON.stringify({
        startDate: exportDateStart,
        endDate: exportDateEnd,
      }),
    })
      .then((res) => {
        if (!res.ok) throw new Error(res.statusText);
        return res.blob();
      })
      .then((blob) => {
        const filename = moment(new Date()).format("YYYYMMDDHHmmss");
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${filename}_ShiftLogReport.${reportType}`;
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove(); //afterwards we remove the element again
        message.success("Shift Log Exported Successfully!");
        this.setState({
          isExportModalVisible: false,
        });
      })
      .catch((err) => {
        message.error(
          err instanceof Error ? err.message : "Server cannot be reached"
        );
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  isValidExportDateRange = (startDate, endDate, showMessage = false) => {
    if (!startDate || !endDate) {
      return false;
    }

    const startDateObj = new Date(startDate);
    const endDateObj = new Date(endDate);

    if (startDateObj > endDateObj) {
      return false;
    }
    const timeDifference = endDateObj.getTime() - startDateObj.getTime();
    const daysDifference = timeDifference / (1000 * 3600 * 24);

    if (daysDifference <= 31) {
      return true;
    }

    if (showMessage) {
      message.warn("Date range cannot be more than 31 days");
    }

    return false;
  };

  render() {
    const {
      logs,
      exportType,
      isExportModalVisible,
      isLoading,
      filterDateTimeStart,
      filterDateTimeEnd,
      filterUserName,
      exportDateStart,
      exportDateEnd,
    } = this.state;
    const { currentLang } = this.props;
    return (
      <div className="site-feature-container">
        <div className="page-header-container">
          <div>
            <div className="page-header-main">Report </div>
            <div className="page-header-sub">Shift Log</div>
          </div>
        </div>
        <Card bodyStyle={flexColumn} style={flexColumnOverflow}>
          <Spin tip="Please Wait..." spinning={isLoading}>
            <Row
              style={{ margin: 0 }}
              className="visitor-history-search-wrapper"
            >
              <Col
                flex="900px"
                className="visitor-detail-group"
                style={{ padding: "0px" }}
              >
                <Row style={{ margin: 0 }}>
                  <Col span={12}>
                    <Input.Group
                      compact
                      className="group-compact-select-wrapper"
                    >
                      <span className="ant-input-group-addon group-addon-label">
                        Start Date
                      </span>
                      <DatePicker
                        style={{ width: "100%" }}
                        showToday={false}
                        showTime={true}
                        placeholder="From"
                        format="DD/MM/YYYY HH:mm"
                        value={filterDateTimeStart}
                        onChange={(evt) => {
                          let newfilterDateTimeEnd =
                            filterDateTimeEnd < evt
                              ? undefined
                              : filterDateTimeEnd;
                          this.setState({
                            logs: [],
                            filterDateTimeStart: evt,
                            filterDateTimeEnd: newfilterDateTimeEnd,
                          });
                        }}
                      />
                    </Input.Group>
                  </Col>
                  <Col style={{ width: "5px" }} />
                  <Col span={10}>
                    <DatePicker
                      style={{ width: "100%" }}
                      showToday={false}
                      showTime={true}
                      value={filterDateTimeEnd}
                      placeholder="To"
                      format="DD/MM/YYYY HH:mm"
                      onChange={(evt) => {
                        let newfilterDateTimeStart =
                          filterDateTimeStart > evt
                            ? undefined
                            : filterDateTimeStart;
                        this.setState({
                          logs: [],
                          filterDateTimeStart: newfilterDateTimeStart,
                          filterDateTimeEnd: evt,
                        });
                      }}
                    />
                  </Col>
                </Row>
                <Row style={{ margin: 0 }}>
                  <Col span={12}>
                    <Input
                      addonBefore="Assigned To"
                      placeholder="Username"
                      name="filterUserName"
                      value={filterUserName}
                      onChange={this.onInputFieldChange}
                    />
                  </Col>
                </Row>
                <div className="visitor-action-group">
                  <Button
                    type="primary"
                    style={{ marginRight: "15px", width: "120px" }}
                    disabled={isLoading}
                    onClick={this.onSearchClick}
                  >
                    {locale.app.common.search[currentLang]}
                  </Button>
                  <Button
                    style={{ marginRight: "15px", width: "120px" }}
                    disabled={!this.isFiltered()}
                    onClick={this.onClearClick}
                  >
                    {locale.app.common.reset[currentLang]}
                  </Button>
                  <Button
                    style={{ marginRight: "15px", width: "120px" }}
                    onClick={() => {
                      this.setState({
                        isExportModalVisible: true,
                        exportType: null,
                        exportDateStart: null,
                        exportDateEnd: null,
                      });
                    }}
                  >
                    {locale.app.common.export[currentLang]}
                  </Button>
                </div>
              </Col>
            </Row>
            <Row style={{ margin: 0 }}>
              <div className="table-section-header">Shift Log</div>
              <Table
                rowKey="id"
                style={{ overflow: "auto", width: "100%" }}
                columns={columns}
                dataSource={logs}
                size="small"
                scroll={{ x: "max-content" }}
              />
            </Row>
          </Spin>
        </Card>
        <Modal
          title={"Export Shift Log"}
          closable={false}
          visible={isExportModalVisible}
          onOk={() => {
            if (exportType) {
              this.getReport(exportType);
            }
          }}
          onCancel={() => {
            this.setState({
              isExportModalVisible: false,
            });
          }}
          okButtonProps={{
            disabled:
              !exportType ||
              isLoading ||
              !exportDateStart ||
              !exportDateEnd ||
              !this.isValidExportDateRange(exportDateStart, exportDateEnd),
          }}
          cancelButtonProps={{ disabled: isLoading }}
        >
          <Form
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            layout="horizontal"
          >
            <Form.Item
              label="Start Date Time"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <DatePicker
                style={{ width: "100%" }}
                showToday={false}
                showTime={true}
                placeholder=" "
                format="DD/MM/YYYY HH:mm"
                value={exportDateStart}
                onChange={(evt) => {
                  this.isValidExportDateRange(evt, exportDateEnd, true);
                  this.setState({
                    exportDateStart: evt,
                  });
                }}
              />
            </Form.Item>
            <Form.Item
              label="End Date Time"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <DatePicker
                style={{ width: "100%" }}
                showToday={false}
                showTime={true}
                placeholder=" "
                format="DD/MM/YYYY HH:mm"
                value={exportDateEnd}
                onChange={(evt) => {
                  this.isValidExportDateRange(exportDateStart, evt, true);
                  this.setState({
                    exportDateEnd: evt,
                  });
                }}
              />
            </Form.Item>
            <Form.Item
              label="Format"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Radio.Group
                options={options}
                onChange={(e) => {
                  this.setState({
                    exportType: e.target.value,
                  });
                }}
                value={exportType}
              />
            </Form.Item>
          </Form>
        </Modal>
      </div>
    );
  }
}
